import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NewIn } from 'src/app/models/types/Rule/Rule.type';
import { ProductComponent } from '../product/product.component';

@Component({
  selector: 'app-new-in',
  templateUrl: './new-in.component.html',
  styleUrl: './new-in.component.scss',
  standalone: false,
})
export class NewInComponent {

  @Input('newIn') newIn?: NewIn;

}
